// ############# GET ACTIVE ##############
const GET_ACTIVE_ARTICLES = "/articles/public";

// ############# GET SINGLE ##############
const GET_BY_ID = "/articles/public";

export const articlesEndpoints = { GET_ACTIVE_ARTICLES, GET_BY_ID };
